import {useContext} from 'react';

import {isNil} from 'lodash';
import {useFormContext} from 'react-hook-form';
import {SeriesContext} from 'ui/contexts/Series';
import getSeriesQuestionSlug from 'ui/utils/getSeriesQuestionSlug';

const useParentValues = (parent?: string) => {
    const {watch} = useFormContext();
    const {seriesIndex, seriesSlug} = useContext(SeriesContext);

    if (!parent) {
        return null;
    }

    return watch(
        !isNil(seriesIndex) && seriesSlug
            ? getSeriesQuestionSlug(seriesSlug, seriesIndex, parent)
            : parent,
    );
};
export default useParentValues;
